/**
 * Component Entry
 *
 */

import Modal from './Modal'
export default Modal
export * from './Modal'
